import parse from 'html-react-parser';

/**
 * html-react-parser throws `TypeError: First argument must be a string` for
 * anything that is not a string — including the `undefined` you get from an
 * optional chain on API or CMS content. With no error boundary in the tree,
 * one missing description takes down the whole render, so every call site
 * fed by remote data goes through this instead of calling parse() directly.
 *
 * @param {*} html - HTML string; anything else yields null.
 * @param {object} [options] - Passed straight through to html-react-parser.
 * @returns {JSX.Element|JSX.Element[]|string|null}
 */
const safeParse = (html, options) =>
  typeof html === 'string' && html !== '' ? parse(html, options) : null;

export default safeParse;
